import { render, staticRenderFns } from "./EHistoricoCaixa.vue?vue&type=template&id=5ac67c54"
import script from "./EHistoricoCaixa.vue?vue&type=script&lang=js"
export * from "./EHistoricoCaixa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports